import styled, { css } from 'styled-components';
import { green, greenLight, gray60, spacer4, spacer16 } from '@spotify-internal/encore-foundation';
import Icon from "./Icon";
import { colors, getColorOrDefault } from "../../styles/theme";
export default styled.li.withConfig({
  displayName: "Step",
  componentId: "sc-1eatjea-0"
})(["color:", ";display:inline-block;position:relative;", ";", ";", ";", ";"], gray60, function (props) {
  return props.active && css(["color:", ";"], getColorOrDefault(props.theme, colors.primaryColorHover, greenLight));
}, function (props) {
  return props.visited && css(["color:", ";"], getColorOrDefault(props.theme, colors.primaryColor, green));
}, function (props) {
  return props.condensed && css(["padding-left:", ";padding-right:", ";&::before{content:'\u2022';display:block;}"], spacer4, spacer4);
}, function (props) {
  return !props.condensed && css(["&:not(:last-child){padding-right:", ";}&:last-child ", "{display:none;}"], spacer16, Icon);
});